import React from 'react';
import styled from 'styled-components';
import * as LucideIcons from 'lucide-react';

interface IconProps {
  name: keyof typeof LucideIcons;
  size?: number;
  color?: string;
  className?: string;
}

const StyledIcon = styled.div<{ $color?: string }>`
  color: ${props => props.$color || props.theme.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Icon: React.FC<IconProps> = ({ name, size = 24, color, className }) => {
  const IconComponent = LucideIcons[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in Lucide icons`);
    return null;
  }

  // Use React.createElement to avoid JSX type issues
  return (
    <StyledIcon $color={color} className={className}>
      {React.createElement(IconComponent as React.ComponentType<any>, { size })}
    </StyledIcon>
  );
};

export default Icon;
export { LucideIcons };
